import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import Hero from '../components/hero'
import Layout from '../components/layout'
import ArticlePreview from '../components/article-preview'

import image from '../images/asx_logo_black.png'

class RootIndex extends React.Component {
  render() {
    const { title: siteTitle, description: siteDescription } = get(
      this,
      'props.data.site.siteMetadata'
    )
    const posts = get(this, 'props.data.allContentfulBlogPost.edges')
    // const [author] = get(this, 'props.data.allContentfulPerson.edges')
    return (
      <Layout location={this.props.location}>
        <div style={{ background: '#fff' }}>
          {/* <Helmet title={siteTitle} /> */}
          <Helmet
            htmlAttributes={{
              lang: 'es',
            }}
            title={siteTitle}
            titleTemplate={`%s | ${siteTitle}`}
          >
            <title>{siteTitle}</title>
            <meta name="description" content={siteDescription} />
            <meta name="image" content={image} />
            {/* <meta name="google-site-verification" content="r41wqXqJhzNSqaaqv77BR28wyM10rtamd7p-bIVlqRE" /> */}

            <meta property="og:url" content={this.props.location.href} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={siteTitle} />
            <meta property="og:description" content={siteDescription} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:creator" content="@ASConsultoresMx" />
            <meta
              name="twitter:site"
              content="https://mobile.twitter.com/ASConsultoresMx"
            />
            <meta name="twitter:title" content={siteTitle} />
            <meta name="twitter:description" content={siteDescription} />
            <meta name="twitter:image" content={image} />
          </Helmet>
          <Hero />
          <div className="wrapper">
            <h2 className="section-headline">Artículos recientes</h2>
            <ul className="article-list">
              {posts.map(({ node }) => {
                return (
                  <li key={node.slug}>
                    <ArticlePreview article={node} />
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </Layout>
    )
  }
}

export default RootIndex

export const pageQuery = graphql`
  query HomeQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
    allContentfulBlogPost(sort: { fields: [publishDate], order: DESC }) {
      edges {
        node {
          title
          slug
          publishDate(formatString: "MMMM Do, YYYY")
          tags
          heroImage {
            fluid(maxWidth: 350, maxHeight: 196, resizingBehavior: SCALE) {
              ...GatsbyContentfulFluid_tracedSVG
            }
          }
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
    # allContentfulPerson(filter: { contentful_id: { eq: "15jwOBqpxqSAOy2eOO4S0m" } }) {
    #   edges {
    #     node {
    #       name
    #       shortBio {
    #         shortBio
    #       }
    #       title
    #       heroImage: image {
    #         fluid(
    #           maxWidth: 1180
    #           maxHeight: 480
    #           resizingBehavior: PAD
    #           background: "rgb:000000"
    #         ) {
    #           ...GatsbyContentfulFluid_tracedSVG
    #         }
    #       }
    #     }
    #   }
    # }
  }
`
